// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c451cf22","455":"b5fa593c"}[chunkId] + ".chunk.js";
};